import cn from 'classnames';
import { Text, type TextProps } from '@direct-frontend/components';
import styles from './FormFieldLabel.module.css';

type FormFieldLabelProps = TextProps & {
    isRequired?: boolean;
};
export const FormFieldLabel = ({ children, isRequired, className, ...props }: FormFieldLabelProps) => (
    <Text
        {...props}
        className={cn(className, styles.root, isRequired && styles.root_required)}
        size="xs"
        role="supplementary"
    >
        {children}
    </Text>
);
